/*
 * How wide a chord symbol is drawn, in em of its own font size — what both bar charts size
 * themselves from: ChordBarsChart to fit a line of bars to the screen, and the builder's grid to fit
 * a bar's chords into the bar.
 *
 * A flat figure per character was the first cut of this, and it was wrong in the direction that
 * shows: chord symbols are built from the widest glyphs in the face — Jost at 600 draws `m` at 0.81em
 * and `G` at 0.80em — so "C#m" really needs 2.15em where 0.58 a character promised 1.74, and the
 * chord printed across the bar line beside it. GLYPH_EM is the face's own advance widths, rounded up,
 * over the alphabet CHORD_TOKEN allows. Over-stating one costs a slightly smaller font than strictly
 * necessary; under-stating it is the bug above.
 */
// prettier-ignore
const GLYPH_EM = {
  A: 0.72, B: 0.64, C: 0.7, D: 0.72, E: 0.59, F: 0.54, G: 0.81,
  '#': 0.65, b: 0.61, '/': 0.58, '^': 0.6,
  M: 0.87, a: 0.53, d: 0.61, g: 0.6, i: 0.28, m: 0.81, n: 0.56, s: 0.44, u: 0.56,
  // Not in a chord, but in the beat counts the builder writes under one ("1.5")
  '.': 0.28,
};
export const DIGIT_EM = 0.66; // the widest of them, for the one or two figures a chord carries
// A rest, drawn as its glyph rather than written: the 1.1em `.RestMark .glyph` takes
export const REST_EM = 1.1;
const FALLBACK_EM = 0.81; // the widest glyph in the face, so an unlisted character is over- rather than under-counted

/*
 * What the inversion mark costs, drawn rather than written. '^1' is stored as two characters and
 * shown as a raised "1st", so measuring the stored form counts glyphs that are never drawn and a
 * size the ordinal is never drawn at. One figure for all three: they are the same three characters
 * wide, and the difference between "1st" and "2nd" is inside the rounding. Estimated rather than
 * measured off the face, so it keeps this file's own bias — over-stated, not under.
 */
const INVERSION_EM = 1.05;

const INVERSION_MARK = /\^[1-3]$/;

export const chordEm = (chord) => {
  const text = String(chord ?? '');
  const marked = INVERSION_MARK.test(text);
  const symbol = marked ? text.slice(0, -2) : text;

  return (
    [...symbol].reduce((total, ch) => total + (GLYPH_EM[ch] ?? (ch >= '0' && ch <= '9' ? DIGIT_EM : FALLBACK_EM)), 0) +
    (marked ? INVERSION_EM : 0)
  );
};
